import { render, staticRenderFns } from "./MintalKpiLayout.vue?vue&type=template&id=f9b64ce0&scoped=true&"
import script from "./MintalKpiLayout.vue?vue&type=script&lang=js&"
export * from "./MintalKpiLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b64ce0",
  null
  
)

export default component.exports